import { ActivityStatusAction } from '../Redux/ActivityStatusActions';
import type { ApplicationAction, ResetError } from '../Redux/ApplicationActions';
import type { ChatEditAction } from '../Redux/ChatEditActions';
import type { ChatListAction } from '../Redux/ChatListActions';
import type { ChatMessageAction } from '../Redux/ChatMessageActions';
import type { ChatroomAction } from '../Redux/ChatroomActions';
import type { LoadingAction } from '../Redux/LoadingActions';

export type Action =
  | ActivityStatusAction
  | ApplicationAction
  | ChatMessageAction
  | ChatEditAction
  | ChatListAction
  | ChatroomAction
  | LoadingAction;

export type ReducerError = {
  uuid: string;
  source: string;
  action: Action;
  error: Error;
};

export const getReducerError = (uuid: string, source: string, action: Action, error: Error): ReducerError => ({
  uuid,
  source,
  action,
  error,
});

export const resetReducerErrors = (reducerErrors: ReducerError[], action: ResetError): ReducerError[] => {
  // Deliberately not putting a try catch in here. If this fails there is no hope for the world :-(
  // an exception will be caught and added to reducer errors and fail again until the stack fills up
  // suppressing the error here still leaves the original error to loop and fill up the stack.
  // Simplest is therefore best. We can reconsider if we get contrary evidence (or a better suggestion)
  const newReducerErrors = reducerErrors.slice();

  for (let i = 0; i < reducerErrors.length; i += 1) {
    if (reducerErrors[i].uuid === action.uuid) {
      reducerErrors.splice(i, 1);
      break;
    }
  }
  return newReducerErrors;
};
